/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable function-paren-newline */
/* eslint-disable comma-dangle */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Autocomplete,
  Grid,
  IconButton,
  Tooltip,
  TextField,
  Typography,
  Link,
  Popper,
  Box,
  Paper,
} from '@mui/material';
import { Field, getIn } from 'formik';
import { ReactComponent as Trash } from '../../../../images/icons/trash.svg';
import NumberFormat from 'react-number-format';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { formatDate, labelField } from 'utils';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import HelpIcon from '@mui/icons-material/Help';
import CycleModal from '../CycleModal';
import ModalShipment from 'modules/production/components/ModalShipment';
import { usePopulation } from 'hooks/usePopulation';
import { availableLots } from 'pages/population/helpers';

function InputGroup({
  index,
  onRemove,
  disableRemoveButton,
  setPondCycles,
  pondCycles,
  setValues,
  location,
  id,
  sizeArrayValues,
  values,
  setFieldValue,
}) {
  const { lots: lotsState, fetchLots } = usePopulation();

  const [openModalShipment, setOpenModalShipment] = useState(false);
  const [openCycleModal, setOpenCycleModal] = useState(false);
  const [selectedLot, setSelectedLot] = useState();
  const [selectedPondCycle, setSelectedPondCycle] = useState();
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [selectedBeginDate, setSelectedBeginDate] = useState(new Date());
  const previousPondRef = useRef(null);
  const [lots, setLots] = useState(lotsState);

  const handleModalShipment = () => {
    setOpenModalShipment((prevState) => !prevState);
  };

  useEffect(() => {
    const { state } = location;
    const { customData, data } = state ?? {};

    if (customData) {
      const formattedDate = formatDate(customData.date);
      setSelectedBeginDate(formattedDate);
    } else if (data) {
      const { cycle, lot, quantity } = data;
      const formattedDate = formatDate(data.date);
      const populations = [
        {
          cycle: cycle.id,
          lot: lot.id,
          quantity: String(quantity),
          size_remain: lot.size_remain,
          date: formattedDate,
        },
      ];
      setValues({ populations });
      setSelectedBeginDate(formattedDate);
    }
  }, [location, setValues]);

  useEffect(() => {
    if (
      pondCycles.length > 0 &&
      index === 0 &&
      location.state?.pond &&
      location.state?.pond !== previousPondRef.current
    ) {
      previousPondRef.current = location.state?.pond;
      const findPondCycles = pondCycles.find((item) =>
        item.pond?.description.includes(location?.state?.pond?.description)
      );
      setFieldValue(`populations.${index}.cycle`, findPondCycles?.id);
      setSelectedPondCycle(findPondCycles);
    }
  }, [index, location.state?.pond, pondCycles, setFieldValue]);

  const retrieveDataThroughLocation = useMemo(() => {
    const { state } = location;

    if (state && index === 0) {
      const { data, customData, pond } = state;

      return data || customData || (pond ? { cycle: pond.description } : null);
    }

    return null;
  }, [index, location]);

  useEffect(() => {
    setLots(availableLots({ values, lots: lotsState }));
  }, [lotsState, values]);

  return (
    <Grid
      container
      spacing={2}
      sx={{ marginBottom: sizeArrayValues === 1 ? 0 : 3 }}
    >
      {openCycleModal && (
        <CycleModal
          openCycleModal={openCycleModal}
          setOpenCycleModal={setOpenCycleModal}
          openLinearProgress={openLinearProgress}
          setOpenLinearProgress={setOpenLinearProgress}
          updateCycles={setPondCycles}
        />
      )}
      <Grid item xs={2.5}>
        <Field name={`populations.${index}.cycle`}>
          {({ field, form }) => {
            const touched = getIn(form.touched, `populations.${index}.cycle`);
            const errors = getIn(form.errors, `populations.${index}.cycle`);

            const valuePondCycle =
              selectedPondCycle ?? retrieveDataThroughLocation?.cycle;

            return (
              <Autocomplete
                {...field}
                disabled={id}
                options={pondCycles}
                onBlur={form.handleBlur}
                value={valuePondCycle}
                getOptionLabel={(option) => option?.pond?.description ?? ''}
                PopperComponent={(param) => (
                  <Popper {...param}>
                    <Box {...param} />
                    <Paper style={{ height: '100%' }}>
                      <Typography style={{ padding: '1rem', color: 'gray' }}>
                        Configurar viveiro para esse ciclo.{' '}
                        <Link
                          style={{ cursor: 'pointer' }}
                          color="primary"
                          onMouseDown={() => {
                            setOpenCycleModal((state) => !state);
                          }}
                        >
                          Configurar agora +
                        </Link>
                      </Typography>
                    </Paper>
                  </Popper>
                )}
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={labelField('Viveiro')}
                    variant="outlined"
                    onBlur={() => form.setFieldTouched(field.name, true)}
                    error={touched && !!errors}
                    helperText={touched && errors}
                  />
                )}
                onChange={(_, value) => {
                  setSelectedPondCycle(value);
                  form.setFieldValue(field.name, value?.id);
                }}
              />
            );
          }}
        </Field>
      </Grid>

      <Grid item xs={2.7}>
        <Field name={`populations[${index}].lot`}>
          {({ field, form }) => {
            const touched = getIn(form.touched, `populations.${index}.lot`);
            const errors = getIn(form.errors, `populations.${index}.lot`);

            return (
              <Autocomplete
                {...field}
                disabled={id}
                open={openAutocomplete}
                onOpen={() => {
                  setOpenAutocomplete((state) => !state);
                }}
                onClose={() => {
                  setOpenAutocomplete((state) => !state);
                }}
                noOptionsText={false}
                options={lots}
                value={selectedLot ?? retrieveDataThroughLocation?.lot}
                getOptionLabel={(option) => option?.name ?? ''}
                onChange={(_, value) => {
                  form.setFieldValue(`populations.${index}.quantity`, '');
                  form.setFieldValue(
                    `populations.${index}.size_remain`,
                    value?.size_remain
                  );
                  setSelectedLot(value);
                  form.setFieldValue(field.name, value?.id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={labelField('Remessa de pós-larva')}
                    onBlur={() => form.setFieldTouched(field.name, true)}
                    error={touched && !!errors}
                    helperText={touched && errors}
                  />
                )}
                PopperComponent={(param) => (
                  <Popper {...param}>
                    <Box {...param} />
                    <Paper style={{ height: '100%' }}>
                      <Typography style={{ padding: '1rem', color: 'gray' }}>
                        {lots.length === 0
                          ? 'Não existe remessa cadastrado nesse povoamento.'
                          : 'Deseja cadastrar outra remessa?'}{' '}
                        <Link
                          style={{ cursor: 'pointer' }}
                          color="primary"
                          onMouseDown={() => {
                            setOpenModalShipment((state) => !state);
                          }}
                        >
                          Cadastrar +
                        </Link>
                      </Typography>
                    </Paper>
                  </Popper>
                )}
              />
            );
          }}
        </Field>
      </Grid>

      <Grid item xs>
        <Field name={`populations[${index}].quantity`}>
          {({ field, form }) => {
            const fieldName = `populations.${index}.quantity`;
            const touched = getIn(form.touched, fieldName);
            const errors = getIn(form.errors, fieldName);
            const valueQuantity = getIn(form.values, fieldName);
            let message = null;
            const quantityParsed = Number(valueQuantity.replaceAll('.', ''));
            const sizeRemain = values.populations[index].size_remain;

            if (sizeRemain && quantityParsed > sizeRemain) {
              message = `Valor precisa ser menor ou igual a capacidade restante de animais (${sizeRemain}).`;
            }

            return (
              <NumberFormat
                {...field}
                fullWidth
                disabled={id}
                inputProps={{ maxLength: 11 }}
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                label={labelField('Qtd. de Animais')}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                isNumericString={false}
                customInput={TextField}
                onBlur={() => form.setFieldTouched(field.name, true)}
                error={touched && (!!errors || !!message)}
                helperText={touched && (errors || message)}
              />
            );
          }}
        </Field>
      </Grid>

      <Grid item xs>
        <Field name={`populations[${index}].size_remain`}>
          {({ field }) => (
            <NumberFormat
              {...field}
              disabled
              style={{ width: '100%' }}
              label={
                <div>
                  Tamanho{' '}
                  <HtmlTooltip
                    title="Tamanho restante da remessa do pós-larva"
                    placement="right"
                    arrow
                  >
                    <HelpIcon color="primary" fontSize="inherit" />
                  </HtmlTooltip>
                </div>
              }
              variant="outlined"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={0}
              fullWidth
              customInput={TextField}
            />
          )}
        </Field>
      </Grid>

      <Grid item xs md={2.5}>
        <Field name={`populations[${index}].date`}>
          {({ field, form }) => {
            const touched = getIn(form.touched, `populations.${index}.date`);
            const errors = getIn(form.errors, `populations.${index}.date`);
            return (
              <LocalizationProvider
                adapterLocale={deLocale}
                dateAdapter={DateFnsUtils}
              >
                <DatePicker
                  {...field}
                  InputLabelProps={{
                    style: { pointerEvents: 'auto' },
                  }}
                  label="Data de Povoamento"
                  variant="inline"
                  inputVariant="outlined"
                  invalidDateMessage="Data Inválida"
                  value={selectedBeginDate}
                  onChange={(date) => {
                    setSelectedBeginDate(date);
                    form.setFieldValue(field.name, date);
                  }}
                  onBlur={() => form.setFieldTouched(field.name, true)}
                  error={touched && !!errors}
                  helperText={touched && errors}
                  fullWidth
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            );
          }}
        </Field>
      </Grid>

      {!id && (
        <Grid
          item
          xs="auto"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Tooltip title="Remover">
            <IconButton
              disabled={disableRemoveButton || index === 0}
              onClick={onRemove}
            >
              <Trash opacity={(disableRemoveButton || index === 0) && 0.5} />
            </IconButton>
          </Tooltip>
        </Grid>
      )}

      {openModalShipment && (
        <ModalShipment
          open={openModalShipment}
          handleClose={handleModalShipment}
          fetchLots={fetchLots}
        />
      )}
    </Grid>
  );
}

export default InputGroup;
